var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 100,
    viewBox: "0 0 82 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.557 53.58C68.43 40.99 78.872 34.95 79.34 34.644c-5.87-8.54-15.01-9.713-18.264-9.846-7.774-.786-15.176 4.558-19.12 4.558-3.936 0-10.03-4.443-16.475-4.33-8.48.126-16.296 4.91-20.66 12.467-8.806 15.21-2.252 37.75 6.33 50.093 4.195 6.034 9.198 12.823 15.762 12.575 6.326-.25 8.713-4.074 16.36-4.074 7.65 0 9.797 4.074 16.49 3.946 6.802-.123 11.115-6.148 15.276-12.206 4.817-7.01 6.8-13.797 6.917-14.14-.148-.07-13.262-5.07-13.398-20.105zM55.983 16.628c3.48-4.207 5.84-10.053 5.198-15.872C56.16.958 50.078 4.08 46.47 8.282c-3.23 3.73-6.057 9.67-5.3 15.383 5.605.433 11.32-2.84 14.813-7.037z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.c4de8afe858fbd960d4e7c898b12f859.svg";
export { ForwardRef as ReactComponent };